<template>
  <BaseModal
    :close-button-visible="false"
    overlay-class="other_modals please_wait no_close"
  >
    <div class="content">
      <DotSpinner />

      <AnimatedDotText text="modal_loader_common_please_wait" />
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import DotSpinner from '@/components/spinner/DotSpinner.vue';
import AnimatedDotText from '@/components/text/AnimatedDotText.vue';
</script>
